import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private supported: boolean | null = null;

  constructor() {}

  get(key: string): string | null {
    if (!this.isSupported()) {
      return null;
    }
    const value: string | null = window.localStorage.getItem(key);
    if (value === null || value === 'null' || value === undefined || value === '') {
      return null;
    }
    return value;
  }

  set(key: string, value: string): void {
    if (!this.isSupported()) {
      return;
    }
    if (value === null || value === undefined || value === '') {
      this.remove(key);
    } else {
      window.localStorage.setItem(key, value);
    }
  }

  remove(key: string): void {
    if (!this.isSupported()) {
      return;
    }
    window.localStorage.removeItem(key);
  }

  private isSupported(): boolean {
    if (this.supported !== null) {
      return this.supported;
    }
    try {
      window.localStorage.setItem('testStorage', '');
      window.localStorage.removeItem('testStorage');
      this.supported = true;
    } catch (error) {
      this.supported = false;
    }
    return this.supported;
  }
}
